module.exports = __webpack_public_path__ + "mt.f1837e40d23ae0d92447.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/mt.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/mt.svg
// module chunks = styles